import { IComboBoxOption } from "@fluentui/react";

export const nativeToolOption: IComboBoxOption[] = [
  {key: 'EB', text: 'EB'},
  {key: 'Eplan', text: 'Eplan'},
  {key: 'E3', text: 'E3'}
];


export const yesNoOption: IComboBoxOption[] = [
  {key: 'Yes', text: 'Yes'},
  {key: 'No', text: 'No'}
];


export const responsibilityTypeOption: IComboBoxOption[] = [
  {key: 'EUOPC', text: 'EUOPC'},
  {key: 'INOPC', text: 'INOPC'},
];


export const cabinetTypeOption: IComboBoxOption[] = [
  {key: 'Controller', text: 'Controller'},
  {key: 'FTCIO', text: 'FTC I/O'},
  {key: 'CTRLIO', text: 'CTRL I/O'},
  {key: 'RIO', text: 'RIO'},
  {key: 'ServerNetwork', text: 'Server/Network'},
  {key: 'CAP', text: 'CAP'},
  {key: 'PDU', text: 'PDU'},

];

export const cabinetAccessTypeOption: IComboBoxOption[] = [
  {key: 'One Side', text: 'One Side'},
  {key: 'Front & Rear', text: 'Front & Rear'},

];

export const accessToSourcesTypeOption: IComboBoxOption[] = [
  {key: 'https://myservices.abb.com/cs_gr?id=esc_sc_cat_item&table=sc_cat_item&sys_id=9615d95a87332e103ba041540cbb358b&searchTerm=Typical%20Cabinet%20Request', text: 'EUOPCTicket'},

];

export const cabinetTypicalStatusOption: IComboBoxOption[] = [
  {key: 'Draft', text: 'Draft'},
  {key: 'InReview', text: 'In Review'},
  {key: 'Approved', text: 'Approved'},
  {key: 'Rejected', text: 'Rejected'},
];

export const controlSystemTypeOption: IComboBoxOption[] = [
  {key: 'S800', text: 'S800'},
  {key: 'AC500', text: 'AC500'},
  {key: 'S900', text: 'S900'},
  {key: 'Advant100450', text: 'Advant100/450'},
  {key: 'Melody', text: 'Melody'},
  {key: 'Harmony', text: 'Harmony'},
];

export const forExAreasTypeOption: IComboBoxOption[] = [
  {key: 'No', text: 'No'},
  {key: 'NonToExi', text: 'NonToExi'},
  {key: 'Exi', text: 'Exi'},
  {key: 'Exd', text: 'Exd'},
  {key: 'Ex', text: 'Ex'},

];

export const industryTypeOption: IComboBoxOption[] = [
  {key: 'N/A', text: 'N/A'},
  {key: 'EN (OGC)', text: 'EN (OGC)'},
  {key: 'MP', text: 'MP'},
  {key: 'P&W', text: 'P&W'},
  {key: 'PI', text: 'PI'},
  {key: 'P&P', text: 'P&P'},

];

export const powerInputOption: IComboBoxOption[] = [
  {key: 'VAC230', text: '230VAC'},
  {key: 'VDC24', text: '24VDC'},
  {key: 'VAC110', text: '110VAC'}
];


export const systemTypeOption: IComboBoxOption[] = [
  {key: 'ESD', text: 'ESD'},
  {key: 'FG', text: 'F&G'},
  {key: 'PCS', text: 'PCS'},
  {key: 'IO', text: 'I/O'}
];

export const yesNoBothOption: IComboBoxOption[] = [
  {key: 'Yes', text: 'Yes'},
  {key: 'No', text: 'No'},
  {key: 'Both', text: 'Both'}
];


export const signalsCountOption: IComboBoxOption[] = [
  {key: '<100', text: '<100'},
  {key: '100-200', text: '100-200'},
  {key: '>200', text: '>200'}
];


export const cableEntryTypeOption: IComboBoxOption[] = [
  {key: 'Top', text: 'Top'},
  {key: 'Bottom', text: 'Bottom'},
];

export const numberOfControllersOptions: IComboBoxOption[] = [
    {key: '1', text: '1'},
    {key: '2', text: '2'},
    {key: '4', text: '4'},
    {key: '8', text: '8'}
  ];





